import React, { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TextField,
  Button,
  Divider,
} from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate , useLocation } from 'react-router-dom';
import { postRequest } from '../../../lib/api'; // adjust path as needed

const VAT_RATE = 0.2;

const LssWills = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const product_id = location.state.product_id;
  const branch_id = location.state.branch_id;

  const singleWillRows = [
    { complexity: 'Low', pointsRange: 'Up to 30' },
    { complexity: 'Medium', pointsRange: '31 - 80' },
    { complexity: 'High', pointsRange: 'Above 81' },
  ];

  const mirrorWillRows = [
    { complexity: 'Low', pointsRange: 'Up to 30' },
    { complexity: 'Medium', pointsRange: '31 - 80' },
    { complexity: 'High', pointsRange: 'Above 81' },
  ];

  const [singleCosts, setSingleCosts] = useState(
    singleWillRows.map(() => ({ mlmLegalCost: '', vat: 0, totalCost: 0 }))
  );

  const [mirrorCosts, setMirrorCosts] = useState(
    mirrorWillRows.map(() => ({ mlmLegalCost: '', vat: 0, totalCost: 0 }))
  );

   const [editId, seteditId] = useState(null);

  const handleChange = (index, value, section) => {
    const cost = parseFloat(value) || 0;
    const vat = parseFloat((cost * VAT_RATE).toFixed(2));
    const total = parseFloat((cost + vat).toFixed(2));
    const updated = [...(section === 'single' ? singleCosts : mirrorCosts)];

    updated[index] = { mlmLegalCost: value, vat, totalCost: total };

    section === 'single' ? setSingleCosts(updated) : setMirrorCosts(updated);
  };

  const renderTable = (rows, costs, sectionTitle, sectionKey) => (
    <Box mb={4}>
      <Typography variant="h6" fontWeight="500" mt={3} mb={1}>
        {sectionTitle}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f4f4f4' }}>
              <TableCell><strong>Type</strong></TableCell>
              <TableCell><strong>No of Points</strong></TableCell>
              <TableCell><strong>MLM Legal Cost</strong></TableCell>
              <TableCell><strong>VAT</strong></TableCell>
              <TableCell><strong>Total Cost</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.complexity}</TableCell>
                <TableCell>{row.pointsRange}</TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    placeholder="£"
                    value={costs[idx].mlmLegalCost}
                    fullWidth
                    onChange={(e) => handleChange(idx, e.target.value, sectionKey)}
                  />
                </TableCell>
                <TableCell>£{costs[idx].vat.toFixed(2)}</TableCell>
                <TableCell>£{costs[idx].totalCost.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  const handleSubmit = async () => {
    if (!product_id || !branch_id) {
      Swal.fire('Error', 'Missing product_id or branch_id', 'error');
      return;
    }

    const singleWill = singleWillRows.map((row, idx) => ({
      complexity: row.complexity,
      pointsRange: row.pointsRange,
      mlmLegalCost: Number(singleCosts[idx].mlmLegalCost),
      vat: singleCosts[idx].vat,
      totalCost: singleCosts[idx].totalCost,
    }));

    const mirrorWill = mirrorWillRows.map((row, idx) => ({
      complexity: row.complexity,
      pointsRange: row.pointsRange,
      mlmLegalCost: Number(mirrorCosts[idx].mlmLegalCost),
      vat: mirrorCosts[idx].vat,
      totalCost: mirrorCosts[idx].totalCost,
    }));

    try {

        const payload = {
      product_id,
        branch_id,
        singleWill,
        mirrorWill,
        
    };
         let res;
        console.log(editId , 'editId@123')
        if (editId) {
          res = await postRequest(`private/editLssWillsCost/${editId}`, payload);
        } else {
          res = await postRequest(`private/createLssWillCost`, payload);
        }
      Swal.fire({
        icon: 'success',
        title: 'Saved',
        text: 'LSS Wills data saved successfully!',
      });

      navigate(-1)
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err?.response?.data?.message || 'Failed to save data.',
      });
    }
  };

  React.useEffect(() => {
    const fetchExistingLpaCosts = async () => {
      try {
        const res = await postRequest(
          `private/getLssWillsCost`,
          { branch_id, product_id }
        );
  
        if (res?.data) {
          seteditId(res?.data?._id);
  
          const singleData = res?.data?.singleWill || [];
          const mirrorData = res?.data?.mirrorWill || [];
         // const codicilData = res?.data?.codicil || null;
  
          const format = (item) => ({
            mlmLegalCost: item?.mlmLegalCost?.toString() || '',
            vat: item?.vat || 0,
            totalCost: item?.totalCost || 0,
          });
  
      
  
          // Ensure mapping aligns with your original 3 entries
          setSingleCosts(singleWillRows.map((_, i) => format(singleData[i] || {})));
          setMirrorCosts(mirrorWillRows.map((_, i) => format(mirrorData[i] || {})));
         // setCodicilCost(format(codicilData[0] || {}));
  
        }
      } catch (error) {
        console.error('Failed to fetch Will cost data', error);
      //  Swal.fire('Error', 'Failed to fetch existing will cost data.', 'error');
      }
    };
  
    if (branch_id && product_id) fetchExistingLpaCosts();
  }, [branch_id, product_id]);

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight={600} mb={2}>
        Manage LSS Wills
      </Typography>

      <Divider sx={{ mb: 2 }} />

      {renderTable(singleWillRows, singleCosts, 'Single Will', 'single')}
      {renderTable(mirrorWillRows, mirrorCosts, 'Mirror Will', 'mirror')}

      <Box mt={2} display="flex" gap={2}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        <Button variant="contained" className='red-bg red-button text-capitalize'
  onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default LssWills;
